<ion-app>
  <ion-router-outlet />
  <p-toast [preventOpenDuplicates]="true" [baseZIndex]="99999" position="top-right" />
</ion-app>
